import { Plus } from "lucide-react";

const ITEMS = [
  "Trusted Healthcare",
  "Delivered Responsibly",
  "Clear Product Information",
  "Worldwide Delivery",
  "Customer Support by Email",
  "Responsible Service",
];

export const Marquee = () => (
  <div className="marquee overflow-hidden border-y border-emerald-900/20 bg-[#0D5C46] py-5" aria-hidden="true">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-lg font-semibold tracking-tight text-white sm:text-xl">
                {item}
              </span>
              <Plus className="mx-8 h-4 w-4 text-emerald-300" strokeWidth={2.5} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
